// Page Loader

window.addEventListener('load', e => {
  let pageLoader = document.querySelector('#page_loader')
  if (pageLoader) {
    setTimeout(()=>{
      pageLoader.classList.remove('active')
    },1000)
  }
})

// Format Money

let formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  let formatString = format || this.money_format

  function defaultOption (opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

function newFormatMoney(cents) {
  let currency = document.body.getAttribute("data-currency")
  let locale = document.body.getAttribute("data-locale")
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }
  if (isNaN(cents)) return ''

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100)
}


function cartMoneyFormat (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  let formatString = format || this.money_format

  function defaultOption (opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

class LocalizationForm extends HTMLElement {
  constructor () {
    super()
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    }
    this.elements.button.addEventListener('click', this.openSelector.bind(this))
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    )
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
  }

  hidePanel () {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
  }

  onContainerKeyUp (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onItemClick (event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.elements.input.value = event.currentTarget.dataset.value
    if (form) form.submit()
  }

  openSelector () {
    this.elements.button.focus()
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString()
    )
  }

  closeSelector (event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel()
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm)
}

let goTopBtns = document.querySelectorAll('.go_to_top')

if (goTopBtns) {
  goTopBtns.forEach(goTopBtn => {
    goTopBtn.addEventListener('click', e => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    })
  })
}

let collectionSection = document.querySelectorAll('.featured-collection-main')
if (collectionSection) {
  collectionSection.forEach(section => {
    let productSingle = section.querySelectorAll(
      '.product_item_main[data-slider]'
    )
    productSingle.forEach((item, index) => {
      item.querySelectorAll("input[type='radio']").forEach(radio => {
        radio.addEventListener('change', () => {
          if (productItemSlider) {
            productItemSlider[index].slideTo(0)
          }
        })
      })
    })
  })
}

// size chart
let chartBtn = document.querySelector('.chart_btn')
if (chartBtn) {
  let chartModal = document.querySelector('.chart_modal')
  let chartClose = document.querySelector('.chart_close')
  chartBtn.addEventListener('click', e => {
    chartModal.classList.add('chart_active')
  })
  chartClose.addEventListener('click', e => {
    chartModal.classList.remove('chart_active')
  })
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      chartModal.classList.remove('chart_active')
    }
  })
}

// SEO & Accessibility

let img = document.querySelectorAll('img')

if (img) {
  img.forEach(image => {
    if (image.hasAttribute('alt') && image.getAttribute('alt') == '') {
      image.setAttribute('alt', 'image')
    }
  })
}

let allBtn = document.querySelectorAll('button')

if (allBtn) {
  allBtn.forEach(button => {
    let text = button.innerText
    if (
      !button.hasAttribute('aria-label') ||
      button.getAttribute('aria-label') == ''
    ) {
      if (text) {
        button.setAttribute('aria-label', text)
      } else if (button.querySelector('.aria-label')) {
        button.setAttribute(
          'aria-label',
          button.querySelector('.aria-label').innerText
        )
      } else {
        button.setAttribute('aria-label', 'button')
      }
    }
  })
}

let link = document.querySelectorAll('a')

if (link) {
  link.forEach(anchor => {
    let text = anchor.innerText
    if (
      !anchor.hasAttribute('aria-label') ||
      anchor.getAttribute('aria-label') == ''
    ) {
      if (text) {
        anchor.setAttribute('aria-label', text)
      } else if (anchor.querySelector('.aria-label')) {
        anchor.classList.add('inline-flex')
        anchor.setAttribute(
          'aria-label',
          anchor.querySelector('.aria-label').innerText
        )
      } else {
        anchor.setAttribute('aria-label', 'link')
      }
    }
    if (anchor.querySelector('button')) {
      anchor.querySelector('button').setAttribute('tabindex', '-1')
    }
    if (!anchor.hasAttribute('href') || anchor.getAttribute('href') == '') {
      anchor.setAttribute('href', '#')
    }
  })
}

let ariaDropdown = document.querySelectorAll('[aria-controls]')

if (ariaDropdown) {
  ariaDropdown.forEach(dropdown => {
    dropdown.setAttribute('aria-expanded', 'false')
    dropdown.addEventListener('click', e => {
      if (
        dropdown.hasAttribute('aria-expanded') ||
        dropdown.getAttribute('aria-expanded') == ''
      ) {
        if (dropdown.getAttribute('aria-expanded') == 'true') {
          dropdown.setAttribute('aria-expanded', 'false')
        } else {
          dropdown.setAttribute('aria-expanded', 'true')
        }
      }
    })
  })
}

// Intersection Observer

const animationSection = document.querySelectorAll('section')

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    entry.target.classList.toggle('sectionanimation', entry.isIntersecting)
    if (entry.isIntersecting) observer.unobserve(entry.target)
  })
})
animationSection.forEach(section => {
  observer.observe(section)
})

// AR Button

function setupShopifyXr () {
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function () {
      setupShopifyXr()
    })
  } else {
    document.querySelectorAll('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
      modelJSON.remove()
    })
    window.ShopifyXR.setupXRElements()
  }
}

window.Shopify.loadFeatures([
  {
    name: 'shopify-xr',
    version: '1.0',
    onLoad: setupShopifyXr
  }
])

// complementary products
if (document.querySelector('.product-complementary')) {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    observer.unobserve(productRecommendationsSection)

    const url = productRecommendationsSection.dataset.url

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-complementary')

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML
        }
       })
       .catch(e => {
         // Error handling omitted
       })
  }

  const productRecommendationsSection = document.querySelector(
    '.product-complementary'
  )
  const newObserver = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
  })

  newObserver.observe(productRecommendationsSection)
}

function priceRangeInput () {
  const rangeInput = document.querySelectorAll('.range-input input')
  if (rangeInput) {
    priceInput = document.querySelectorAll('.price-input input')
    progress = document.querySelector('.slider .progress')

    let priceGap = 1

    function rangeUpdate (target) {
      let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value)

      if (maxVal - minVal < priceGap) {
        if (target.className === 'range-min') {
          rangeInput[1].value = minVal + priceGap
        } else {
          rangeInput[0].value = maxVal - priceGap
        }
        minVal = parseInt(rangeInput[0].value)
        maxVal = parseInt(rangeInput[1].value)
      }

      priceInput[0].value = minVal
      priceInput[1].value = maxVal
      progress.style.left = (minVal / rangeInput[1].max) * 100 + '%'
      progress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%'
    }

    rangeInput.forEach(input => {
      rangeUpdate(input)
      input.addEventListener('input', e => {
        rangeUpdate(e.target)
      })
    })
  }
}

priceRangeInput()

// Focal Points

let focalPoints = document.querySelectorAll('.focal-point')
if (focalPoints && window.matchMedia('(min-width:768px)').matches) {
  focalPoints.forEach(focalPoint => {
    focalPoint.querySelector('.focal-btn').addEventListener('click', e => {
      e.preventDefault()
      focalPoint.classList.toggle('focal-active')
    })
  })
}

// Size Chart

let sizeCharts = document.querySelectorAll('.chart_modal')
if (sizeCharts) {
  sizeCharts.forEach(sizeChart => {
    let sizeBtn = sizeChart.parentElement.querySelector('.size_chart_btn')
    if (sizeBtn && sizeChart) {
      let closeBtn = sizeChart.querySelector('.chart_close')
      closeBtn.addEventListener('click', e => {
        sizeChart.classList.remove('chart_active')
      })
      sizeBtn.addEventListener('click', e => {
        sizeChart.classList.add('chart_active')
      })
    }
  })
}
